import { Input } from 'ui'
import { ControlledField } from './ControlledField'
import { SigningFormFieldProps } from './Switcher'

const sleep = (ms = 0) => new Promise((r) => setTimeout(r, ms))

export const TextField = (props: SigningFormFieldProps ) => {
  return (
    <ControlledField {...props}>
      {({ field }) => (
        <Input
          {...field}
          onBlur={() => {
            field.onBlur()
            props.onPersist(field.value)
          }}
          id={props.field.id}
          style={{
            fontSize:'inherit'
          }}
          className='bg-white w-full h-full rounded-none focus-visible:ring-black p-0'
          placeholder={props.field.label}
        />
      )}
    </ControlledField>
  )
}
